<template>
    <section class="section categories-manager-page">
        <div class="container-fluid">
            <div class="columns">
                <div class="column">
                    <h1 class="title">{{ translate("page.category_manager.title") }}</h1>
                </div>
            </div>

            <div v-if="!store.initDone" class="columns is-centered">
                <LoadingSpinner2 class="has-added-margin" />
            </div>

            <ChoosingSetupPathScreen v-else-if="store.showFourPathScreen" />

            <ImportFromTemplate v-else-if="store.showImportFromTemplate" />

            <ExtractFromRules v-else-if="store.showExtractFromRules" />

            <CategoriesManager v-else-if="store.showTreeBuilder" :event-id="eventId" :category-translation-keys="categoryTranslationKeys" />
        </div>

        <ImportFromPastEventModal ref="importFromPastEventModal" />
    </section>
</template>

<script setup lang="ts">
    import ChoosingSetupPathScreen from "./ChoosingSetupPathScreen.vue";
    import ImportFromTemplate from "./ImportFromTemplate.vue";
    import ExtractFromRules from "./ExtractFromRules.vue";
    import CategoriesManager from "./CategoriesManager.vue";
    import ImportFromPastEventModal from "./ImportFromPastEventModal.vue";
    import LoadingSpinner2 from "../Common/LoadingSpinner2.vue";
    import { translate } from "../Common/translations";
    import { handleError } from "../Common/errorHandler";
    import { useCategoriesManagerStore } from "./categoriesManagerStore";
    import { eventBus, OPEN_IMPORT_FROM_PAST_EVENT_MODAL } from "./eventBus";
    import { onMounted, ref } from "vue";
    import type { ComponentExposed } from "vue-component-type-helpers";

    const props = defineProps<{
        eventId: number;
        categoryTranslationKeys: Record<string, string>;
        isFullOrganizer: boolean;
        eventTimezone: string;
        currentUserId?: number | null;
    }>();

    const store = useCategoriesManagerStore();
    const importFromPastEventModal = ref<ComponentExposed<typeof ImportFromPastEventModal>>();

    onMounted(() => {
        store.eventId = props.eventId;
        store.categoryTranslationKeys = props.categoryTranslationKeys;
        store.isFullOrganizer = props.isFullOrganizer;
        store.eventTimezone = props.eventTimezone;
        store.currentUserId = props.currentUserId ?? null;

        eventBus.$on(OPEN_IMPORT_FROM_PAST_EVENT_MODAL, () => {
            importFromPastEventModal.value?.open();
        });

        return store.initialize().catch(handleError);
    });
</script>
